import { render, staticRenderFns } from "./CarbonSegmentEdit.vue?vue&type=template&id=48d1627c&"
import script from "./CarbonSegmentEdit.vue?vue&type=script&lang=js&"
export * from "./CarbonSegmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports